export const NAME = 'previewNotes';